(function() {
  angular.module('admin')
  .controller('corporateTaxIdController',
    ['$scope', '$log', 'MyDso', '$state', 'secSecurityService', 'FileUploader', '$cookies', '$uibModal', '$window',
    function($scope, $log, MyDso, $state, secSecurityService, FileUploader, $cookies, $uibModal, $window) {
      var vm = this;
      vm.dso = getDso();
      vm.file = '';
      vm.running = false;
      vm.maxAllowedFileSize = 20000000;
      getDsoDocuments();
      secSecurityService.hasAnyAuthority('PREVIOUS_ADMINISTRATOR').then((val) => {
        vm.inUserView = val;
      });
      $scope.$watch('errorControl', function() {
        $scope.errorControl && $scope.errorControl.showErrors();
      });
      vm.uploader = new FileUploader({
        url: '/myDso/document',
        queueLimit: 1,
        removeAfterUpload: true,
        headers:  getHeaders()
      });
      vm.uploader.onProgressItem = function(evt) {
        vm.running = true;
      };
      vm.uploader.onSuccessItem = function(item,response) {
        vm.running = false;
        vm.uploadedDocument = response;
        vm.files.push(response.filename);
        vm.file='';
      };
      vm.uploader.onErrorItem = function(item, response) {
        vm.running = false;
        throw response;
      };
      vm.uploader.onAfterAddingFile = function(item){
        if (_.find(vm.files,function(f){return f.toLowerCase() == item.file.name.toLowerCase();})) {
            $scope.corporateTaxIdForm.locationsFile.$setValidity('uniqueList', false);
            item.cancel();
        }else{
          if (isSupportedItem(item)) {
            $scope.corporateTaxIdForm.locationsFile.$setValidity('uniqueList', true);
          }else{
            item.cancel();
          }
        }
      };
      vm.upload = function(item) {
        $scope.errorControl.showErrors();
        if (isSupportedItem(item)){
          vm.uploader.uploadItem(item);
        }else{
          vm.uploader.cancelItem(item);
        }
      };
      vm.reset = function(){
        vm.file='';
        $scope.corporateTaxIdForm.locationsFile.$setValidity('uniqueList', true);
        $scope.corporateTaxIdForm.locationsFile.$setValidity('fileType', true);
        $scope.corporateTaxIdForm.locationsFile.$setValidity('fileSize', true);
      };
      $scope.$watchCollection('vm.uploader.queue',(q)=>{
          vm.item = q ? q[0] : '';
      });
      vm.updateFilesList = function(){
        getDsoDocuments();
      };
      function getHeaders() {
        return {'x-auth-token' : $cookies.get('x-auth-token')};
      }
      function getDso() {
        vm.running = true;
        return MyDso().get(function(dso) {
          vm.running = false;
          return dso;
        },function(error){
           vm.running = false;
           throw error;
        });
      }
      function isSupportedItem(item) {
        var type = '|' + item.file.type.slice(item.file.type.lastIndexOf('/') + 1) + '|';
        var supportedType = '|csv|vnd.ms-excel|vnd.openxmlformats-officedocument.spreadsheetml.sheet|'.indexOf(type) !== -1 ;
        var validFileSize = item.file.size <= vm.maxAllowedFileSize;
        $scope.corporateTaxIdForm.locationsFile.$setValidity('fileType', supportedType);
        $scope.corporateTaxIdForm.locationsFile.$setValidity('fileSize', validFileSize);
        return supportedType && validFileSize;
      }
      function getDsoDocuments() {
        vm.running = true;
        MyDso().getDsoDocuments(function(data) {
          vm.running = false;
          vm.files = (data && data.documents ? _.map(data.documents,(d) => {return d.filename;}) : []);
        },function(error){
           vm.running = false;
           throw error;
        });
      }
    }]);
})();
